export default __webpack_public_path__ + "static/media/phone.4ed2ba86.svg";